import { Button } from '@/components/ui/button';
import { Dialog } from '@/components/ui/dialog';
import { Input, Label } from '@/components/ui/input';
import { formatDate } from '@/lib/utils';

// Postpone a marked tenant's removal (Cleanup page + tenant page). The new
// date counts from the current due date, or from now once that has passed —
// same as the backend's GREATEST(removal_due_at, now()) + days.
export function PostponeDialog({
  tenantId,
  dueAt,
  days,
  onDays,
  pending,
  error,
  onCancel,
  onConfirm,
}: {
  tenantId: string | null;
  dueAt: string | null;
  days: number;
  onDays: (d: number) => void;
  pending: boolean;
  error?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const base = dueAt && Date.parse(dueAt) > Date.now() ? Date.parse(dueAt) : Date.now();
  const newDue = new Date(base + Math.max(0, days) * 86_400_000).toISOString();
  return (
    <Dialog
      open={tenantId !== null}
      onOpenChange={(o) => !pending && !o && onCancel()}
      title={
        <>
          Postpone removal of <span className="font-mono text-slate-600">{tenantId}</span>
        </>
      }
      footer={
        <>
          <Button variant="outline" onClick={onCancel} disabled={pending}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={pending || days < 1}>
            {pending ? 'Postponing…' : 'Postpone'}
          </Button>
        </>
      }
    >
      <div className="space-y-3">
        <div className="w-40">
          <Label>Postpone by (days)</Label>
          <Input
            type="number"
            min={1}
            value={days}
            onChange={(e) => onDays(Math.max(0, Math.floor(Number(e.target.value) || 0)))}
          />
        </div>
        <p className="text-sm text-slate-700">
          New removal date: <b>{formatDate(newDue)}</b>. Until then no sweep touches this account. Your
          system gets a <code className="font-mono text-xs">tenant.removal_postponed</code> webhook.
        </p>
        {error && <div className="text-xs text-red-600 bg-red-50 rounded-md px-3 py-2">{error}</div>}
      </div>
    </Dialog>
  );
}
